import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { dashboardsAppReducer } from '../genericDashboard/redux/dashboards.app.reducer';
import { accordionsSearchReducer } from '@nirvana/redux/searchable-ui-accordions';
import { policiesAppReducer } from '../policies/endpoints/policyPanel/redux/slice';

export const store = configureStore({
  reducer: {
    dashboardsApp: dashboardsAppReducer,
    accordionsSearchApp: accordionsSearchReducer,
    policiesApp: policiesAppReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
